import { ItemStatus, itemStatusConfig } from '@/constants/item'
import { useUI } from '@/hooks/useUI'

export function ItemStatusBadge({ status }: { status: ItemStatus }) {
  const { itemStatuses, language, getEnumLabel } = useUI()
  const config = itemStatusConfig[status]
  if (!config) return null
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-medium  ${config.bgColor} ${config.color}`}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {getEnumLabel(itemStatuses, status)}
    </span>
  )
}
